module.exports = __webpack_public_path__ + "img/File.affe1e95.svg";